<template>
  <el-dialog title="聊天" :close-on-click-modal="false" :show-close="false" custom-class="poster-dialog"
             :visible.sync="visible" width="90%" center @closed="dialogClosed">
    <div class="chat-container">
      <!-- 标题栏 -->
      <div class="chat-header">
        <div class="header-content">
          <div class="order-info">
            <div class="order-details">
              <div class="detail-row">
                <span class="order-number">
                  客户名称: {{ orderInfo.customerNameNode || '' }}
                </span>
              </div>
              <div class="detail-row">
                <span class="order-number">
                  路线: {{ ((orderInfo.cityNode || '').replace(/省|市|区/g, '')) + ((orderInfo.areaNode || '').replace(/省|市|区/g, '')) }} --------- {{ ((orderInfo.giveAddressInfo.city || '').replace(/省|市|区/g, '')) + ((orderInfo.giveAddressInfo.area || '').replace(/省|市|区/g, '')) }}
                </span>
              </div>
              <div class="detail-row">
                <span class="order-number">
                  报关: {{ orderInfo.orderInfo.entranceTypeName ? orderInfo.orderInfo.entranceTypeName : '一般贸易' }}
                </span>
              </div>
              <div class="detail-row">
                <span class="order-number">
                  货物: {{ (orderInfo.orderGoods.goodsName ? orderInfo.orderGoods.goodsName : '') + ' | ' + (orderInfo.orderGoods.packTypeName ? orderInfo.orderGoods.packTypeName : '') }}
                </span>
              </div>
              <div class="detail-row">
                <span class="order-number">
                  车型: {{ (orderInfo.vehicleTypeNameNode ? orderInfo.vehicleTypeNameNode : '') + (orderInfo.orderInfo.isTailstock && orderInfo.orderInfo.isTailstock == 1 ? ' | ' + '有尾板' : '') }}
                </span>
              </div>
            </div>
          </div>
          <div class="header-actions">
            <el-button type="text" @click="() => visible = false">
              <i class="el-icon-close"></i>
            </el-button>
          </div>
        </div>
      </div>

      <!-- 聊天消息区域 -->
      <div class="chat-messages" ref="messagesContainer">
        <div
            v-for="(message, index) in messages"
            :key="index"
            class="message-wrapper"
            :class="{ 'own-message': currentUser.id == (message.sendMessageSourceId || '') }"
        >
          <div class="message-avatar">
            <!--<el-avatar :src="message.avatar" shape="square"></el-avatar>-->
          </div>
          <div class="message-content">
            <div class="message-info">
              <span class="message-time">{{ message.createTime }}</span>
              <span class="message-sender">{{ message.sendName }}</span>
            </div>
            <div
                class="message-bubble"
                :class="{
                 'text-message': message.messageType == '0',
                 'image-message': message.messageType == '1',
                 'video-message': message.messageType == '2',
                 'file-message': message.messageType == '3',
                 'audio-message': message.messageType == '4',

            }"
            >
              <!-- 文本消息 -->
              <div v-if="message.messageType === '0'" class="text-content">{{ message.messageContent }}</div>

              <!-- 图片消息 -->
              <div v-if="message.messageType === '1'" class="media-content">
                <el-image
                    :src="domain + message.messageContent"
                    :preview-src-list="[domain + message.messageContent]"
                    fit="cover"
                    class="media-element"
                    :class="{ 'own-media': currentUser.id == (message.sendMessageSourceId || '') }"
                >
                  <div slot="placeholder" class="image-loading">
                    <i class="el-icon-loading"></i>
                  </div>
                </el-image>
              </div>

              <!-- 视频消息 -->
              <div v-if="message.messageType === '2'" class="media-content">
                <video controls class="media-element" :class="{ 'own-media': currentUser.id == (message.sendMessageSourceId || '') }">
                  <source :src="domain + message.messageContent" type="video/mp4">
                  您的浏览器不支持视频播放
                </video>
                <div class="video-play-icon">
                  <i class="el-icon-video-play"></i>
                </div>
              </div>

              <!-- 文件消息 -->
              <div v-if="message.messageType === '3'" class="file-content" :class="{ 'own-file': currentUser.id == (message.sendMessageSourceId || '') }">
                <!--<div class="file-icon">-->
                <!--  <i :class="getFileIcon(message.fileType)"></i>-->
                <!--</div>-->
                <!--<div class="file-info">-->
                <!--  <div class="file-name">{{ message.fileName }}</div>-->
                <!--  <div class="file-size">{{ formatFileSize(message.fileSize) }}</div>-->
                <!--</div>-->
                <div class="file-actions">
                  <el-button type="text" @click="downloadFile(domain + message.messageContent)" class="download-btn">
                    <i class="el-icon-download"></i>
                  </el-button>
                </div>
              </div>

              <!-- 语音消息 -->
              <div v-if="message.messageType === '4'" class="audio-content" :class="{ 'own-audio': currentUser.id == (message.sendMessageSourceId || '') }">
                <div class="audio-wave">
                  <span v-for="n in 20" :key="n" :style="waveStyle(n)"></span>
                </div>
                <audio controls :src="domain + message.messageContent"></audio>
                <!--<span class="audio-duration">{{ message.duration }}″</span>-->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 消息输入区域 -->
      <div class="chat-input">
        <!-- 工具栏 -->
        <div class="toolbar">
          <el-button-group>
            <el-tooltip content="表情" placement="top">
              <el-button size="small" @click="showEmojiPicker = !showEmojiPicker" class="tool-btn">
                <i class="el-icon-star-on"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip content="图片" placement="top">
              <el-button size="small" @click="triggerFileInput('image')" class="tool-btn">
                <i class="el-icon-picture-outline-round"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip content="视频" placement="top">
              <el-button size="small" @click="triggerFileInput('video')" class="tool-btn">
                <i class="el-icon-video-camera-solid"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip content="语音" placement="top">
              <el-button size="small" @click="triggerFileInput('audio')" class="tool-btn">
                <i class="el-icon-microphone"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip content="文件" placement="top">
              <el-button size="small" @click="triggerFileInput('file')" class="tool-btn">
                <i class="el-icon-folder-opened"></i>
              </el-button>
            </el-tooltip>
          </el-button-group>

          <!-- 隐藏的文件输入 -->
          <input
              v-if="fileCheck"
              type="file"
              ref="fileInput"
              style="display: none"
              @change="handleFileUpload"
              :accept="fileInputAccept"
          >
        </div>

        <!-- 表情选择器 -->
        <transition name="fade">
          <div v-if="showEmojiPicker" class="emoji-picker">
          <span
              v-for="(emoji, index) in emojis"
              :key="index"
              @click="insertEmoji(emoji)"
              class="emoji-item"
          >{{ emoji }}</span>
          </div>
        </transition>

        <!-- 文本输入区 -->
        <div class="input-area">
          <el-input
              type="textarea"
              :rows="3"
              placeholder="输入消息..."
              v-model="inputMessage"
              @keyup.enter.native="sendMessage"
              resize="none"
              class="message-textarea"
          ></el-input>
          <el-button
              type="primary"
              size="small"
              class="send-button"
              @click="sendMessage"
              :disabled="!inputMessage.trim()"
              :class="{ 'pulse': inputMessage.trim() }"
          >
            发送 <i class="el-icon-s-promotion"></i>
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {getClone} from "@/utils/myJsonClone";

export default {
  name: 'ChatBox',
  data() {
    return {
      visible: false,
      orderInfo: {
        orderInfo: {},
        orderGoods: {},
        giveAddressInfo: {}
      },
      domain: '',
      fileCheck: true,
      interval: null,

      messages: [
        //{
        //  id: 1,
        //  sender: '对方用户',
        //  avatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
        //  content: '你好，这是一个测试消息！',
        //  type: 'text',
        //  time: new Date(Date.now() - 3600000),
        //  isOwn: false
        //},
        //{
        //  id: 2,
        //  sender: '当前用户',
        //  avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        //  content: '你好，我这边可以发送各种类型的消息！',
        //  type: 'text',
        //  time: new Date(Date.now() - 1800000),
        //  isOwn: true
        //},
        //{
        //  id: 3,
        //  sender: '对方用户',
        //  avatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
        //  content: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        //  type: 'image',
        //  time: new Date(Date.now() - 1200000),
        //  isOwn: false
        //},
        //{
        //  id: 4,
        //  sender: '当前用户',
        //  avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        //  content: 'https://www.w3schools.com/html/mov_bbb.mp4',
        //  type: 'video',
        //  time: new Date(Date.now() - 600000),
        //  isOwn: true
        //},
        //{
        //  id: 5,
        //  sender: '对方用户',
        //  avatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
        //  content: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
        //  type: 'audio',
        //  time: new Date(Date.now() - 300000),
        //  duration: 15,
        //  isOwn: false
        //}
      ],
      inputMessage: '',
      showEmojiPicker: false,
      fileInputType: 'file',
      fileInputAccept: '*',
      recording: false,
      audioRecorder: null,
      audioChunks: [],
      emojis: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😬', '🙄', '😯', '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐', '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕', '🤑', '🤠', '😈', '👿', '👹', '👺', '🤡', '💩', '👻', '💀', '☠️', '👽', '👾', '🤖', '🎃', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾'],

    };
  },
  created() {
    let that = this
    that.$http({
      url: that.$http.adornUrl('/sys/appConfig/get'),
      method: 'get',
      params: that.$http.adornParams({ type: 2 })
    }).then(({ data }) => {
      this.domain = JSON.parse(data.configValue).spaceDomain
    })
  },
  mounted() {},
  beforeDestroy() {
    this.dialogClosed()
  },
  computed: {
    currentUser: {
      get () {
        return this.$store.state.user.currentUser
      }
    }
  },
  methods: {
    // 初始化数据
    async init(row) {
      this.messages = []
      // 加载数据
      this.orderInfo = await getClone(row);
      await this.loadMessages()
      this.visible = true;
      this.scrollToBottom()

      // 每2秒自动处理消息
      this.interval = setInterval(() => {
        this.loadMessages();
      },2000);
    },

    // 加载数据
    async loadMessages() {
      this.$http({
        url: this.$http.adornUrl('/oder-info-message/list/' + this.orderInfo.orderInfo.id),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.length > 0) {
          if (this.messages.length < data.length) {
            this.messages = this.messages.concat(data.slice(this.messages.length));
          }
        }
      })
    },

    // 发送文本消息
    sendMessage() {
      if (!this.inputMessage.trim()) return;

      // 添加消息
      this.$http({
        url: this.$http.adornUrl('/oder-info-message/sendMessage'),
        method: 'post',
        data: this.$http.adornData({messageContent: this.inputMessage,sourceId: this.orderInfo.orderInfo.id})
      }).then(({data}) => {
        if (data) {
          this.messages.push(data)
          this.inputMessage = '';
          this.scrollToBottom();
        }
      })
    },

    // 发送图文/文件/视频/音频消息
    triggerFileInput(type) {
      this.fileInputType = type;

      switch (type) {
        case 'image':
          this.fileInputAccept = 'image/*';
          break;
        case 'video':
          this.fileInputAccept = 'video/*';
          break;
        case 'audio':
          this.fileInputAccept = 'audio/*';
          break;
        default:
          this.fileInputAccept = '*';
      }

      setTimeout(() => {
        this.$refs.fileInput.click();
      },500)
    },
    handleFileUpload(event) {
      try {
        this.fileCheck = false;
        let that = this
        const file = event.target.files[0];
        if (!file) return;

        let messageType = 1;
        if (this.fileInputType === 'image' && file.type.startsWith('image/')) {
          messageType = 1
        } else if (this.fileInputType === 'video' && file.type.startsWith('video/')) {
          messageType = 2
        } else if (this.fileInputType === 'audio' && file.type.startsWith('audio/')) {
          messageType = 4
        } else {
          messageType = 3
        }

        // 2. 创建FormData对象（用于文件上传）
        const formData = new FormData();
        formData.append('file', file);
        formData.append('businessType', 88888);
        // 3. 发送请求（使用axios或你的this.$http）
        this.$http({
          url: this.$http.adornUrl('/upload/file'),
          method: 'post',
          data: formData
        }).then(({data}) => {
          if (data) {
            // 添加消息
            this.$http({
              url: this.$http.adornUrl('/oder-info-message/sendMessage'),
              method: 'post',
              data: this.$http.adornData({
                messageContent: data.url,
                sourceId: that.orderInfo.orderInfo.id,
                messageType: messageType
              })
            }).then(({data}) => {
              if (data) {
                this.messages.push(data)
                event.target.value = '';
                this.scrollToBottom();
              }
            })
          }
        }).catch(error => {
          console.error('上传失败:', error);
          this.$message.error('文件上传失败');
        });
      } finally {
        this.fileCheck = true
      }
    },

    downloadFile(url) {
      const a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    insertEmoji(emoji) {
      this.inputMessage += emoji;
      this.showEmojiPicker = false;
    },

    getFileIcon(fileType) {
      if (!fileType) return 'el-icon-document';

      if (fileType.includes('pdf')) return 'el-icon-document-pdf';
      if (fileType.includes('word')) return 'el-icon-document';
      if (fileType.includes('excel')) return 'el-icon-document-excel';
      if (fileType.includes('powerpoint')) return 'el-icon-document-ppt';
      if (fileType.includes('zip') || fileType.includes('rar') || fileType.includes('7z')) return 'el-icon-folder-opened';
      if (fileType.includes('text')) return 'el-icon-document-text';

      return 'el-icon-document';
    },

    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      return `${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`;
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i]);
    },

    waveStyle(n) {
      const height = Math.random() * 15 + 5;
      return {
        height: `${height}px`,
        animationDelay: `${n * 0.05}s`
      };
    },

    handleScroll() {
      const container = this.$refs.messagesContainer;
      if (container.scrollTop === 0 && !this.isLoading && this.hasMore) {
        this.loadMessages();
      }
    },
    scrollToBottom(behavior = 'smooth') {
      setTimeout(() => {
        this.$nextTick(() => {
          const container = this.$refs.messagesContainer;
          if (!container) {
            console.error('Messages container not found');
            return;
          }
          // 强制重排确保DOM更新
          void container.offsetHeight;
          container.scrollTo({
            top: container.scrollHeight,
            behavior: behavior === 'auto' ? 'auto' : 'smooth'
          });
          container.scrollTop = container.scrollHeight;
        });
      },1000)
    },

    // 关闭前的处理
    dialogClosed() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  },

};
</script>

<style scoped>
/* 基础样式 */
.chat-container {
  display: flex;
  flex-direction: column;
  height: 700px;
  max-width: 700px;
  margin: 0 auto;
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  background-color: #f8f9fa;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

/* 新增加载指示器样式 */
.loading-indicator {
  text-align: center;
  padding: 10px;
  color: #999;
  font-size: 14px;
}

.loading-indicator i {
  margin-right: 5px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


/* 标题栏样式 */
.chat-header {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  padding: 10px 20px;
  min-height: 80px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10;
}

.order-info {
  flex: 1;
}

.order-title {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
}

.order-details {
  display: flex;
  flex-direction: column;
}

.detail-row {
  display: flex;
  margin-bottom: 4px;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.order-number {
  display: flex;
  align-items: center;
  margin-right: 20px;
  font-size: 13px;
  line-height: 1.4;
}

.order-number i {
  margin-right: 5px;
  font-size: 14px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.header-actions {
  display: flex;
}

.header-actions .el-button {
  color: white;
  padding: 8px;
  font-size: 16px;
  transition: all 0.2s;
}

.header-actions .el-button:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
}


/* 消息区域 */
.chat-messages {
  flex: 1;
  overflow-y: auto;
  height: 0;
  min-height: 0;
}

.chat-messages::-webkit-scrollbar {
  width: 6px;
}

.chat-messages::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

/* 消息包装 */
.message-wrapper {
  display: flex;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  animation: fadeIn 0.3s ease-out;
}

.message-wrapper.own-message {
  flex-direction: row-reverse;
}

/* 头像 */
.message-avatar {
  margin: 0 12px;
  align-self: flex-end;
}

.el-avatar {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.el-avatar:hover {
  transform: scale(1.1);
}

/* 消息内容 */
.message-content {
  max-width: 65%;
  min-width: 120px;
}

.message-info {
  margin-bottom: 6px;
  font-size: 12px;
  color: #6c757d;
  display: flex;
  align-items: center;
}

.own-message .message-info {
  flex-direction: row-reverse;
}

.message-sender {
  font-weight: 600;
  margin-right: 8px;
  color: #495057;
}

.own-message .message-sender {
  color: #2c3e50;
}

.message-time {
  font-size: 11px;
  color: #adb5bd;
}

/* 消息气泡 */
.message-bubble {
  padding: 12px 16px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;
  transition: all 0.2s;
}

.text-message {
  background-color: #ffffff;
  color: #333;
  border-top-left-radius: 0;
}

.own-message .text-message {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  border-top-right-radius: 0;
}

.image-message, .video-message {
  padding: 0;
  overflow: hidden;
  background-color: transparent;
  box-shadow: none;
}

.audio-message {
  padding: 10px 15px;
  background-color: #f1f3f5;
  border-top-left-radius: 0;
}

.own-message .audio-message {
  background: linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%);
  border-top-right-radius: 0;
}

.file-message {
  padding: 12px;
  background-color: #ffffff;
  border-top-left-radius: 0;
}

.own-message .file-message {
  background: linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%);
  border-top-right-radius: 0;
}

/* 媒体内容 */
.media-content {
  max-width: 300px;
  max-height: 300px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.media-element {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s;
}

.media-element:hover {
  transform: scale(1.02);
}

.video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 40px;
  color: white;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  opacity: 0.8;
}

/* 音频内容 */
.audio-content {
  display: flex;
  align-items: center;
  padding: 8px 12px;
}

.audio-wave {
  display: flex;
  align-items: center;
  height: 30px;
  margin-right: 10px;
}

.audio-wave span {
  display: inline-block;
  width: 2px;
  margin: 0 1px;
  background-color: #6c757d;
  border-radius: 2px;
  animation: wave 1.5s infinite ease-in-out;
}

.own-audio .audio-wave span {
  background-color: white;
}

@keyframes wave {
  0%, 100% {
    transform: scaleY(0.5);
  }
  50% {
    transform: scaleY(1);
  }
}

.audio-duration {
  font-size: 12px;
  color: #6c757d;
  margin-left: 8px;
}

.own-audio .audio-duration {
  color: rgba(255, 255, 255, 0.8);
}

/* 文件内容 */
.file-content {
  display: flex;
  align-items: center;
}

.file-icon {
  font-size: 36px;
  margin-right: 12px;
  color: #4facfe;
}

.own-file .file-icon {
  color: white;
}

.file-info {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-weight: 600;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #343a40;
}

.own-file .file-name {
  color: white;
}

.file-size {
  font-size: 11px;
  color: #6c757d;
}

.own-file .file-size {
  color: rgba(255, 255, 255, 0.8);
}

.file-actions {
  margin-left: 10px;
}

.download-btn {
  color: #6c757d;
  font-size: 16px;
}

.own-file .download-btn {
  color: white;
}

/* 输入区域 */
.chat-input {
  border-top: 1px solid #e9ecef;
  background-color: white;
  padding: 10px;
}

.toolbar {
  padding: 8px 0;
  display: flex;
  align-items: center;
}

.tool-btn {
  border: none;
  background: none;
  font-size: 18px;
  color: #6c757d;
  margin-right: 5px;
  padding: 8px 12px;
  border-radius: 50%;
  transition: all 0.2s;
}

.tool-btn:hover {
  background-color: #f1f3f5;
  color: #4facfe;
  transform: scale(1.1);
}

/* 表情选择器 */
.emoji-picker {
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  max-height: 150px;
  overflow-y: auto;
  border-top: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
  background-color: white;
}

.emoji-item {
  font-size: 22px;
  margin: 5px;
  cursor: pointer;
  transition: all 0.2s;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.emoji-item:hover {
  background-color: #f1f3f5;
  transform: scale(1.2);
}

/* 输入区域 */
.input-area {
  position: relative;
  padding-top: 10px;
}

.message-textarea >>> .el-textarea__inner {
  border: none;
  background-color: #f8f9fa;
  border-radius: 12px;
  padding-right: 80px;
  box-shadow: none;
  transition: all 0.3s;
}

.message-textarea >>> .el-textarea__inner:focus {
  background-color: white;
  box-shadow: 0 0 0 2px rgba(79, 172, 254, 0.2);
}

.send-button {
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 50px;
  padding: 8px 20px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(79, 172, 254, 0.3);
  transition: all 0.3s;
}

.send-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);
}

.send-button:active {
  transform: translateY(0);
}

.send-button i {
  margin-left: 5px;
}

.pulse {
  animation: pulse 1.5s infinite;
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(79, 172, 254, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(79, 172, 254, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(79, 172, 254, 0);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .chat-container {
    height: 100vh;
    border-radius: 0;
  }

  .message-content {
    max-width: 75%;
  }
}
</style>
